import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Badge, Button, Row, Col, Alert } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { LoginManager } from '../../core/login-manager';
import moment from 'moment';
import ImportXmlMetron from '../components/ImportXmlMetron';
import ImportXml3Cad from '../components/ImportXmlCad';
import { settings } from '../settings';
import Swal from 'sweetalert2';



export default function InstanceCompilerTopHook({ data, entity = null, setDataKeyValue }) {

    var userInfo = LoginManager.getUserInfo();
    var now = moment();
    var location = useLocation();

    const [customerData, setCustomerData] = useState(null);

    useEffect(() => {
        async function loadCustomerData() {
            let customerId = null;

            if (entity === 'customer_order_delivery' && data?.idCustomerOrder?.idCustomer) {
                customerId = typeof data.idCustomerOrder.idCustomer === 'object'
                    ? data.idCustomerOrder.idCustomer.id
                    : data.idCustomerOrder.idCustomer;
            } else if (entity === 'activity' && data?.idCustomer) {
                customerId = typeof data.idCustomer === 'object'
                    ? data.idCustomer.id
                    : data.idCustomer;
            }

            if (customerId) {
                const res = await DataManager.getItemSimple('customer', customerId);
                if (res.success === 1 && res.body && res.body.length > 0) {
                    setCustomerData(res.body[0]);
                }
            } else {
                setCustomerData(null);
            }
        }
        loadCustomerData();
    }, [entity, data?.idCustomerOrder?.idCustomer, data?.idCustomer]);


    // Enable status field for admin users (level 0)
    useEffect(() => {
        if (userInfo && userInfo.level === 0) {
            const statusEntities = ['customer_offer', 'customer_order', 'supplier_order', 'customer_order_delivery', 'customer_order_row', 'supplier_order_row', 'customer_order_delivery_row'];
            if (statusEntities.includes(entity)) {
                var field = document.getElementById(`${entity}_field_status`);
                if (field) {
                    var input = field.querySelector('select') || field.querySelector('input');
                    if (input) {
                        input.disabled = false;
                    }
                }
            }
        }
    }, [entity, userInfo, data]);

    useEffect(() => {
        if (entity == 'customer_order') {
            var rows = data.rows
            if (rows && rows.length > 0 && data.orderDate && data.orderDate !== null) {
                var maxDate = moment(data.orderDate)
                for (let i = 0; i < rows.length; i++) {
                    var r = rows[i]
                    if (r.idSupplier !== null) {
                        if (r.idSupplier.deliveryTime) {
                            var tempDate = moment(data.orderDate, "YYYY-MM-DD").add(r.idSupplier.deliveryTime, 'days').format("YYYY-MM-DD")
                            if (moment(tempDate) > maxDate) {
                                maxDate = moment(tempDate)
                            }
                        }
                    }
                }
                if (data.deliveryDate !== moment(maxDate).format("YYYY-MM-DD")) {
                    setDataKeyValue('deliveryDate', moment(maxDate).format("YYYY-MM-DD"))
                }
            }
        }
        if (entity === 'customer') {
            if (data.idVatCondition === "") {
                (async () => {
                    try {
                        var res = await DataManager.searchItems(
                            'vat_condition', 1, 1,
                            { field: 'id', order: 'ASC' },
                            '', [],
                            [{ fieldName: 'defaultVat', type: 'value', value: 1 }]
                        );
                        if (res.success === 1 && res.body && res.body.length > 0) {
                            setDataKeyValue('idVatCondition', res.body[0]);
                        }
                    } catch (e) { }
                })();
            }
        }
        if (entity === 'customer_offer') {
            console.warn(data)
            if (data.idCustomer && data.idCustomer !== null) {
                if (data.idPaymentCondition === "" && data.idPaymentCondition !== data.idCustomer.idPaymentCondition) {
                    setDataKeyValue('idPaymentCondition', data.idCustomer.idPaymentCondition)
                }
                if (data.idVatCondition === "") {
                    if (data.idCustomer.idVatCondition) {
                        setDataKeyValue('idVatCondition', data.idCustomer.idVatCondition)
                    } else {
                        (async () => {
                            try {
                                var res = await DataManager.searchItems(
                                    'vat_condition', 1, 1,
                                    { field: 'id', order: 'ASC' },
                                    '', [],
                                    [{ fieldName: 'defaultVat', type: 'value', value: 1 }]
                                );
                                if (res.success === 1 && res.body && res.body.length > 0) {
                                    setDataKeyValue('idVatCondition', { id: res.body[0].id, name: res.body[0].name });
                                }
                            } catch (e) { }
                        })();
                    }
                }
            }
            if (data.rows.length > 0) {

                var count = 0;
                for (let i = 0; i < data.rows.length; i++) {
                    if (data.rows[i].price !== "0") {
                        count++;
                    }
                    var totale = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.price))
                    }, 0)
                    var totaleIva = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.vatPrice))
                    }, 0)
                    var totalListPrice = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.listPrice) * item.quantity)
                    }, 0)
                }
                if (data.totalRows !== parseFloat(totale).toFixed(2)) {
                    setDataKeyValue('totalRows', totale.toFixed(2))
                }
                if (data.totalListPrice !== parseFloat(totalListPrice).toFixed(2)) {
                    setDataKeyValue('totalListPrice', totalListPrice.toFixed(2))
                }
                var totale1 = parseFloat(totale);
                var totaleIVA = parseFloat(totaleIva);


                if (settings.iva_esclusa) {
                    totale1 = totale1 + totaleIVA;
                }



                if (data.totalPrice !== totale1.toFixed(2)) {
                    setDataKeyValue('totalPrice', totale1.toFixed(2))
                }
                if (data.totalVat !== totaleIVA.toFixed(2)) {
                    setDataKeyValue('totalVat', totaleIVA.toFixed(2))
                }

                //calcolo del totale sconti
                var totalDiscounts = data.rows.map((item) => {
                    var t = (parseFloat(item.listPrice) * (parseFloat(item.discountOffer) / 100)) + (parseFloat(item.discount));
                    return Number(t.toFixed(2))
                })

                totalDiscounts = totalDiscounts.reduce((acc, num) => acc + parseFloat(num), 0);

                if (data.totalDiscount !== totalDiscounts) {
                    setDataKeyValue('totalDiscount', totalDiscounts)
                }

            }
        }
        if (entity === 'customer_order') {
            console.warn(data)
            if (data.idCustomer && data.idCustomer !== null) {
                if (data.idPaymentCondition === "" && data.idPaymentCondition !== data.idCustomer.idPaymentCondition) {
                    setDataKeyValue('idPaymentCondition', data.idCustomer.idPaymentCondition)
                }
                if (data.idVatCondition === "") {
                    if (data.idCustomer.idVatCondition) {
                        setDataKeyValue('idVatCondition', data.idCustomer.idVatCondition)
                    } else {
                        (async () => {
                            try {
                                var res = await DataManager.searchItems(
                                    'vat_condition', 1, 1,
                                    { field: 'id', order: 'ASC' },
                                    '', [],
                                    [{ fieldName: 'defaultVat', type: 'value', value: 1 }]
                                );
                                if (res.success === 1 && res.body && res.body.length > 0) {
                                    setDataKeyValue('idVatCondition', { id: res.body[0].id, name: res.body[0].name });
                                }
                            } catch (e) {}
                        })();
                    }
                }
                if (data.deliveryAddress === "" && data.deliveryAddress !== data.idCustomer.address) {
                    setDataKeyValue('deliveryAddress', data.idCustomer.address);
                    setDataKeyValue('latitude', data.idCustomer.latitude);
                    setDataKeyValue('longitude', data.idCustomer.longitude);
                }
            }
            if (data.rows.length > 0) {
                var count = 0;
                for (let i = 0; i < data.rows.length; i++) {
                    if (data.rows[i].price !== "0") {
                        count++;
                    }
                    var totale = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.price))
                    }, 0)
                    var totaleIva = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.vatPrice))
                    }, 0)
                    var totalListPrice = data.rows.reduce((acc, item) => {
                        return acc + (parseFloat(item.listPrice) * item.quantity)
                    }, 0)
                }
                if (data.totalRows !== parseFloat(totale).toFixed(2)) {
                    setDataKeyValue('totalRows', totale.toFixed(2))
                }
                if (data.totalListPrice !== parseFloat(totalListPrice).toFixed(2)) {
                    setDataKeyValue('totalListPrice', totalListPrice.toFixed(2))
                }
                var totale1 = parseFloat(totale);
                var totaleIVA = parseFloat(totaleIva);

                if (settings.iva_esclusa) {
                    totale1 = totale1 + totaleIVA;
                }

                if (data.totalPrice !== totale1.toFixed(2)) {
                    setDataKeyValue('totalPrice', totale1.toFixed(2))
                }
                if (data.totalVat !== totaleIVA.toFixed(2)) {
                    setDataKeyValue('totalVat', totaleIVA.toFixed(2))
                }


                //calcolo del totale sconti
                var totalDiscounts = data.rows.map((item) => {
                    var t = parseFloat(item.listPrice) * (parseFloat(item.discountOrder) / 100) + parseFloat(item.discount);
                    return Number(t.toFixed(2))
                })

                console.log(totalDiscounts)
                var totalDiscounts1 = totalDiscounts.reduce((acc, num) => acc + num, 0);


                if (data.totalDiscount !== parseFloat(totalDiscounts1).toFixed(2)) {
                    setDataKeyValue('totalDiscount', parseFloat(totalDiscounts1).toFixed(2))
                }
            }
        }
        if (entity === 'supplier_order') {
            if (data.idSupplier && data.idSupplier !== null) {
                if (data.idPaymentCondition !== data.idSupplier.idPaymentCondition) {
                    setDataKeyValue('idPaymentCondition', data.idSupplier.idPaymentCondition)
                }
            }
            if (data.file && data.file !== null) {
                var field = document.getElementById("supplier_order_field_confirmedDeliveryDate").querySelector("input");
                field.required = true
            }
            if (data.idCustomerOrder && data.idCustomerOrder !== null && data.idCustomerOrder.idCustomer) {
                if (data.customerName !== data.idCustomerOrder.idCustomer.name) {
                    setDataKeyValue('customerName', data.idCustomerOrder.idCustomer.name)
                }
            }
            /* if (location.pathname === '/entity/supplier_order/edit') {
                var field = document.getElementById("supplier_order_field_rows");
                if (field) {
                    field.remove()
                }
            } */
            if (userInfo && userInfo.level > 0) {
                var field = document.getElementById("supplier_order_field_rows");
                if (field) {
                    field.remove()
                }
            }
        }
        if (entity === 'customer_offer_row') {



            const discountPercentageInput = document.querySelector("#customer_offer_row_field_discountPercentage input");
            const discountInput = document.querySelector("#customer_offer_row_field_discount input");


            if (document.activeElement === discountPercentageInput) {
                var a = ((parseFloat(data.quantity) * parseFloat(data.listPrice)) * parseFloat(data.discountPercentage) / 100).toFixed(2)
                if (data.discount !== a) {
                    setDataKeyValue('discount', a)
                }
            } else if (document.activeElement === discountInput) {
                var a = (parseFloat(data.quantity) * parseFloat(data.listPrice)) ? ((data.discount / (parseFloat(data.quantity) * parseFloat(data.listPrice))) * 100).toFixed(2) : 0;
                if (data.discountPercentage !== a) {
                    setDataKeyValue('discountPercentage', a)
                }
            }


            if (!settings.sconti) {
                if (data.discount !== "0") {
                    document.querySelector('#customer_offer_row_field_discount input').disabled = true;
                    setDataKeyValue('discount', "0")
                }
                if (data.discountPercentage !== "0") {
                    document.querySelector('#customer_offer_row_field_discountPercentage input').disabled = true;
                    setDataKeyValue('discountPercentage', "0")
                }
            }
            if (data.idSupplier !== "") {
                if (data.discountPercentage === "0" && data.discountPercentage !== data.idSupplier.sale_discount) {
                    setDataKeyValue('discountPercentage', data.idSupplier.sale_discount)
                }
            }
            var fieldDiscount = document.querySelector("#customer_offer_field_discount input");
            if (data.discountOffer && fieldDiscount && fieldDiscount.value !== "0") {
                if (data.discountOffer !== fieldDiscount.value) {
                    setDataKeyValue('discountOffer', fieldDiscount.value)
                }
            }
            // Leggi VAT dal parent: se idVatCondition presente usa percentage, altrimenti usa vat, altrimenti 22
            var fieldVatCondition = document.querySelector("#customer_offer_field_idVatCondition");
            var vatConditionId = null;
            if (fieldVatCondition) {
                var elWithDataId = fieldVatCondition.querySelector('[data-id]');
                if (elWithDataId) {
                    vatConditionId = elWithDataId.getAttribute('data-id');
                }
            }
            if (vatConditionId) {
                (async () => {
                    try {
                        var res = await DataManager.getItemSimple('vat_condition', vatConditionId);
                        if (res.success === 1 && res.body && res.body.length > 0 && res.body[0].percentage) {
                            if (data.vat !== res.body[0].percentage) {
                                setDataKeyValue('vat', res.body[0].percentage);
                            }
                        }
                    } catch (e) { }
                })();
            }
            if (data.listPrice) {
                var t = parseFloat(data.listPrice) * parseFloat(data.quantity);
                if (data.discountOffer !== "") {
                    var t1 = ((t * 1) * (data.discountOffer * 1) / 100)
                }
                if (data.discount !== "") {
                    var t2 = data.discount
                }
                t = t - t1 - t2;
                t = parseFloat(t).toFixed(2)
                if (data.price !== t) {
                    setDataKeyValue('price', t)
                }
                if (data.price !== "0" && data.vat !== "") {
                    if (settings.iva_esclusa) {
                        console.log((parseFloat(data.vat) / 100) * parseFloat(data.price))
                        var a = (parseFloat(data.vat) / 100) * parseFloat(data.price)
                        var b = a + parseFloat(data.price)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== parseFloat(b).toFixed(2)) {
                            setDataKeyValue('totalPrice', parseFloat(b).toFixed(2))
                        }
                    } else {
                        var a = parseFloat(data.price) * ((parseFloat(data.vat) / 100) / (1 + (parseFloat(data.vat) / 100)))
                        a = parseFloat(a).toFixed(2)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== t) {
                            setDataKeyValue('totalPrice', t)
                        }

                    }
                }

            }
            if (data.idCategory !== "" && data.description === "") {
                if (data.idCategory && (data.idCategory.description !== "" && data.idCategory.description !== null)) {
                    setDataKeyValue('description', data.idCategory.description)
                }
            }
            if (data.listPrice === "" || data.price === "") {
                Swal.fire({ title: 'Attenzione', text: 'Attenzione! I campi prezzo non possono essere vuoti, inserire 0.', icon: 'warning', confirmButtonColor: '#ffc107' })
            }

        }
        if (entity === 'customer_order_row') {


            const discountPercentageInput = document.querySelector("#customer_order_row_field_discountPercentage input");
            const discountInput = document.querySelector("#customer_order_row_field_discount input");


            if (document.activeElement === discountPercentageInput) {
                var a = ((parseFloat(data.quantity) * parseFloat(data.listPrice)) * parseFloat(data.discountPercentage) / 100).toFixed(2)
                if (data.discount !== a) {
                    setDataKeyValue('discount', a)
                }
            } else if (document.activeElement === discountInput) {
                var a = (parseFloat(data.quantity) * parseFloat(data.listPrice)) ? ((data.discount / (parseFloat(data.quantity) * parseFloat(data.listPrice))) * 100).toFixed(2) : 0;
                if (data.discountPercentage !== a) {
                    setDataKeyValue('discountPercentage', a)
                }
            }


            if (!settings.sconti) {
                if (data.discount !== "0") {
                    document.querySelector('#customer_order_row_field_discount input').disabled = true;
                    setDataKeyValue('discount', "0")
                }
                if (data.discountPercentage !== "0") {
                    document.querySelector('#customer_order_row_field_discountPercentage input').disabled = true;
                    setDataKeyValue('discountPercentage', "0")
                }
            }
            console.warn(data)
            if (data.idSupplier !== "") {
                console.log(data.discountPercentage, data.idSupplier.sale_discount)
                if (data.discountPercentage === "0" && data.discountPercentage !== data.idSupplier.sale_discount) {
                    setDataKeyValue('discountPercentage', data.idSupplier.sale_discount)
                }
            }
            var fieldDiscount = document.querySelector("#customer_order_field_discount input");
            if (data.discountOrder && fieldDiscount && fieldDiscount.value !== "0") {
                if (data.discountOrder !== fieldDiscount.value) {
                    setDataKeyValue('discountOrder', fieldDiscount.value)
                }
            }
            // Leggi VAT dal parent: se idVatCondition presente usa percentage, altrimenti usa vat, altrimenti 22
            var fieldVatCondition = document.querySelector("#customer_order_field_idVatCondition");
            var vatConditionId = null;
            if (fieldVatCondition) {
                var elWithDataId = fieldVatCondition.querySelector('[data-id]');
                if (elWithDataId) {
                    vatConditionId = elWithDataId.getAttribute('data-id');
                }
            }
            if (vatConditionId) {
                (async () => {
                    try {
                        var res = await DataManager.getItemSimple('vat_condition', vatConditionId);
                        if (res.success === 1 && res.body && res.body.length > 0 && res.body[0].percentage) {
                            if (data.vat !== res.body[0].percentage) {
                                setDataKeyValue('vat', res.body[0].percentage);
                            }
                        }
                    } catch (e) { }
                })();
            }
            if (data.listPrice) {
                var t = parseFloat(data.listPrice) * parseFloat(data.quantity);
                if (data.discountOrder !== "") {
                    var t1 = ((t * 1) * (data.discountOrder * 1) / 100)
                }
                if (data.discount !== "") {
                    var t2 = data.discount
                    console.log(t)
                }
                t = t - t1 - t2;
                if (data.price !== t) {
                    setDataKeyValue('price', t)
                }
                if (data.price !== "0" && data.vat !== "") {
                    if (settings.iva_esclusa) {
                        console.log((parseFloat(data.vat) / 100) * parseFloat(data.price))
                        var a = (parseFloat(data.vat) / 100) * parseFloat(data.price)
                        var b = a + parseFloat(data.price)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== parseFloat(b).toFixed(2)) {
                            setDataKeyValue('totalPrice', parseFloat(b).toFixed(2))
                        }
                    } else {
                        var a = parseFloat(data.price) * ((parseFloat(data.vat) / 100) / (1 + (parseFloat(data.vat) / 100)))
                        a = parseFloat(a).toFixed(2)
                        if (data.vatPrice !== a) {
                            setDataKeyValue('vatPrice', a)
                        }
                        if (data.totalPrice !== t) {
                            setDataKeyValue('totalPrice', t)
                        }

                    }
                }
            }
            if (data.idCategory !== "" && data.description === "") {
                if (data.idCategory && (data.idCategory.description !== "" && data.idCategory.description !== null)) {
                    setDataKeyValue('description', data.idCategory.description)
                }
            }
            if (data.listPrice === "" || data.price === "") {
                Swal.fire({ title: 'Attenzione', text: 'Attenzione! I campi prezzo non possono essere vuoti, inserire 0.', icon: 'warning', confirmButtonColor: '#ffc107' })
            }

        }
        if (entity === 'notification') {

            console.warn(data)
            if (data.notificationAll === 0) {
                if (data.notificationOrder !== 0) {
                    setDataKeyValue('notificationOrder', 0);

                }
                if (data.notificationOffer !== 0) {
                    setDataKeyValue('notificationOffer', 0);

                }
            }


        }
        if (entity === 'customer_order_payment') {
            console.warn(data)
            if (data.paymentDate === "") {
                var today = now.format('YYYY-MM-DD');
                if (data.paymentDate !== today) {
                    setDataKeyValue('paymentDate', today);
                }
            }
            if (data.idCustomerOrder && data.idCustomerOrder !== "") {
                if (data.idCustomerOrder && data.idCustomerOrder.idCustomer) {
                    if (data.idCustomer !== data.idCustomerOrder.idCustomer) {
                        setDataKeyValue('idCustomer', data.idCustomerOrder.idCustomer)
                    }
                }
            }
        }
        if (entity === 'supplier') {
            if (data.cash_flow_discount === "" || data.commercial_discount === "" || data.sale_discount === "") {
                Swal.fire({ title: 'Attenzione', text: 'Attenzione! I campi sconto non possono essere vuoti, inserire 0.', icon: 'warning', confirmButtonColor: '#ffc107' })
            }
        }
        if (entity === 'customer_order_delivery') {
            console.log(data)
            if (data.idCustomerOrder) {
                localStorage.setItem("idCustomerOrder", data.idCustomerOrder.id)
                if (data.realDeliveryDate === "") {
                    if (data.realDeliveryDate !== data.idCustomerOrder.realDeliveryDate) {
                        setDataKeyValue('realDeliveryDate', data.idCustomerOrder.realDeliveryDate)
                    }
                }
                if (data.finishDeliveryDate === "") {
                    if (data.finishDeliveryDate !== data.idCustomerOrder.finishDeliveryDate) {
                        setDataKeyValue('finishDeliveryDate', data.idCustomerOrder.finishDeliveryDate)
                    }
                }
                if (data.deliveryAddress === "") {
                    if (data.deliveryAddress !== data.idCustomerOrder.deliveryAddress) {
                        setDataKeyValue('deliveryAddress', data.idCustomerOrder.deliveryAddress)
                    }
                }
                if (data.locality === "") {
                    if (data.locality !== data.idCustomerOrder.locality) {
                        setDataKeyValue('locality', data.idCustomerOrder.locality)
                    }
                }
                if (data.latitude === "") {
                    if (data.latitude !== data.idCustomerOrder.latitude) {
                        setDataKeyValue('latitude', data.idCustomerOrder.latitude)
                    }
                }
                if (data.longitude === "") {
                    if (data.longitude !== data.idCustomerOrder.longitude) {
                        setDataKeyValue('longitude', data.idCustomerOrder.longitude)
                    }
                }
                if (data.idUserDelivery === "") {
                    if (data.idUserDelivery !== data.idCustomerOrder.idUserDelivery) {
                        setDataKeyValue('idUserDelivery', data.idCustomerOrder.idUserDelivery)
                    }
                }
                if (data.notes === "") {
                    if (data.notes !== data.idCustomerOrder.notes) {
                        setDataKeyValue('notes', data.idCustomerOrder.notes)
                    }
                }
            }
        }
        if (entity === 'customer_order_delivery_row') {
            console.log(data)
            if (data.idCustomerOrderRow) {
                if (data.name === "") {
                    if (data.name !== data.idCustomerOrderRow.name) {
                        setDataKeyValue('name', data.idCustomerOrderRow.name)
                    }
                }
                if (data.description === "") {
                    if (data.description !== data.idCustomerOrderRow.description) {
                        setDataKeyValue('description', data.idCustomerOrderRow.description)
                    }
                }
                if (data.supplier === "") {
                    if (data.supplier !== (data.idCustomerOrderRow.idSupplier && data.idCustomerOrderRow.idSupplier.name)) {
                        setDataKeyValue('supplier', (data.idCustomerOrderRow.idSupplier && data.idCustomerOrderRow.idSupplier.name))
                    }
                }
                if (data.quantity) {
                    if (data.quantity !== data.idCustomerOrderRow.quantity) {
                        setDataKeyValue('quantity', data.idCustomerOrderRow.quantity)
                    }
                }
                if (data.notes === "") {
                    if (data.notes !== data.idCustomerOrderRow.notes) {
                        setDataKeyValue('notes', data.idCustomerOrderRow.notes)
                    }
                }
            }
        }
    }, [data]);


    /* useEffect(() => {
        if (entity === 'customer_offer') {
            if (data.rows.length > 0) {
                var clone = data.rows.map(obj => ({
                    ...obj,
                    discountOffer: data.discount,
                    price: (parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount),
                    vatPrice: settings.iva_esclusa ? (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) : (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100) / (1 + (parseFloat(obj.vat) / 100))),
                    totalPrice: settings.iva_esclusa ? ((((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) + ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))) : ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))

                }))
                console.log(clone)
                setDataKeyValue('rows', clone)
            }
        }
        if (entity === 'customer_order') {
            if (data.rows.length > 0) {
                var clone = data.rows.map(obj => ({
                    ...obj,
                    discountOrder: data.discount,
                    price: (parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount),
                    vatPrice: settings.iva_esclusa ? (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) : (((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100) / (1 + (parseFloat(obj.vat) / 100))),
                    totalPrice: settings.iva_esclusa ? ((((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount)) * (parseFloat(obj.vat) / 100)) + ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))) : ((parseFloat(obj.listPrice) * parseFloat(obj.quantity)) - (parseFloat(obj.listPrice) * (parseFloat(obj.discountPercentage) / 100)) - (parseFloat(obj.listPrice) * (parseFloat(data.discount) / 100)) - parseFloat(obj.discount))

                }))
                console.log(clone)
                setDataKeyValue('rows', clone)
            }
        }
    }, [data.discount]) */


    useEffect(() => {
        if (entity === "customer_offer_row") {
            var a = ((parseFloat(data.quantity) * parseFloat(data.listPrice)) * parseFloat(data.discountPercentage) / 100).toFixed(2)
            if (data.discount !== a) {
                setDataKeyValue('discount', a)
            }
            /* if (parseFloat(data.discountPercentage).toFixed(2) !== "0.00" && parseFloat(data.discount).toFixed(2) !== "0.00") {
                var a = (parseFloat(data.discount) / (parseFloat(data.quantity) * parseFloat(data.listPrice)) * 100).toFixed(2)
                if (data.discountPercentage !== a) {
                    setDataKeyValue('discountPercentage', a)
                }
            } */
        }
        if (entity === "customer_order_row") {
            var a = ((parseFloat(data.quantity) * parseFloat(data.listPrice)) * parseFloat(data.discountPercentage) / 100).toFixed(2)
            if (data.discount !== a) {
                setDataKeyValue('discount', a)
            }
            /* if (parseFloat(data.discountPercentage).toFixed(2) !== "0.00" && parseFloat(data.discount).toFixed(2) !== "0.00") {
                var a = (parseFloat(data.discount) / (parseFloat(data.quantity) * parseFloat(data.listPrice)) * 100).toFixed(2)
                if (data.discountPercentage !== a) {
                    setDataKeyValue('discountPercentage', a)
                }
            } */
        }
    }, [data.listPrice])


    useEffect(() => {
        if (entity === "customer_offer_row") {
            var a = ((parseFloat(data.quantity) * parseFloat(data.listPrice)) * parseFloat(data.discountPercentage) / 100).toFixed(2)
            if (data.discount !== a) {
                setDataKeyValue('discount', a)
            }
            /* if (parseFloat(data.discountPercentage).toFixed(2) !== "0.00" && parseFloat(data.discount).toFixed(2) !== "0.00") {
                var a = (parseFloat(data.discount) / (parseFloat(data.quantity) * parseFloat(data.listPrice)) * 100).toFixed(2)
                if (data.discountPercentage !== a) {
                    setDataKeyValue('discountPercentage', a)
                }
            } */
        }
        if (entity === "customer_order_row") {
            var a = ((parseFloat(data.quantity) * parseFloat(data.listPrice)) * parseFloat(data.discountPercentage) / 100).toFixed(2)
            if (data.discount !== a) {
                setDataKeyValue('discount', a)
            }
            /* if (parseFloat(data.discountPercentage).toFixed(2) !== "0.00" && parseFloat(data.discount).toFixed(2) !== "0.00") {
                var a = (parseFloat(data.discount) / (parseFloat(data.quantity) * parseFloat(data.listPrice)) * 100).toFixed(2)
                if (data.discountPercentage !== a) {
                    setDataKeyValue('discountPercentage', a)
                }
            } */
        }
    }, [data.quantity])




    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'customer_order': return (
                            <>
                                <Row className='my-3'>
                                    <Col md={9}>
                                        {location && location.pathname === "/entity/customer_order/edit" ? <>
                                            <Alert variant='warning'>
                                                <b>Codice interno ordine:</b> {data.internalCode}
                                            </Alert>
                                        </> : <>
                                            {data.idCustomer ? <>
                                                <Alert variant='warning'>
                                                    <b>Indirizzo di consegna suggerito: </b>{data.idCustomer.address}
                                                </Alert>
                                            </> : <></>}
                                        </>}
                                    </Col>
                                    <Col>
                                        <Container fluid className='text-end mb-2'>
                                            <ImportXmlMetron data={data} entity={entity} setDataKeyValue={setDataKeyValue} />
                                            <ImportXml3Cad data={data} entity={entity} setDataKeyValue={setDataKeyValue} />
                                        </Container>
                                    </Col>
                                </Row>
                            </>

                        );
                        case 'customer_offer': return (
                            <>
                                <Row className='my-3'>
                                    <Col md={9}>
                                        {location && location.pathname === "/entity/customer_offer/edit" ? <>
                                            <Alert variant='warning'>
                                                <b>Codice interno preventivo:</b> {data.internalCode}
                                            </Alert>
                                        </> : <>
                                            {data.idCustomer ? <>
                                                <Alert variant='warning'>
                                                    <b>Indirizzo di consegna suggerito: </b>{data.idCustomer.address}
                                                </Alert>
                                            </> : <></>}
                                        </>}
                                    </Col>
                                    <Col>
                                        <Container fluid className='text-end mb-2'>
                                            <ImportXmlMetron data={data} entity={entity} setDataKeyValue={setDataKeyValue} />
                                            <ImportXml3Cad data={data} entity={entity} setDataKeyValue={setDataKeyValue} />
                                        </Container>
                                    </Col>
                                </Row>
                            </>

                        );
                        case 'customer_order_delivery': return (
                            <>

                                <Row className='my-3'>
                                    <Col>
                                        {location && location.pathname === "/entity/customer_order_delivery/edit" ? <>
                                            <Alert variant='warning'>
                                                <b>Codice interno consegna:</b> {data.internalCode}
                                            </Alert>
                                        </> : <>
                                            {data.idCustomerOrder ? <>
                                                <Alert variant='warning'>
                                                    <p className='mb-1'><b>Cliente: </b>{customerData?.name || ''} {customerData?.surname || ''}</p>
                                                    <p className='mb-1'><b>Telefono: </b>{customerData?.phone || '-'}</p>
                                                    <p className='mb-0'><b>Indirizzo di consegna suggerito: </b>{data.idCustomerOrder.deliveryAddress}</p>
                                                </Alert>
                                            </> : <></>}
                                        </>}
                                    </Col>
                                </Row>
                            </>

                        );
                        case 'supplier_order': return (
                            <>
                                <Row className='my-3'>
                                    <Col>
                                        {location && location.pathname === "/entity/supplier_order/edit" ? <>
                                            <Alert variant='warning'>
                                                <b>Codice interno ordine fornitore:</b> {data.internalCode}
                                            </Alert>
                                        </> : <>
                                        </>}
                                    </Col>
                                </Row>
                            </>

                        );
                        case 'activity': return (
                            <>
                                {data.idCustomer && customerData ? (
                                    <Row className='my-3'>
                                        <Col>
                                            <Alert variant='info'>
                                                <p className='mb-1'><b>Cliente: </b>{customerData?.name || ''} {customerData?.surname || ''}</p>
                                                <p className='mb-0'><b>Telefono: </b>{customerData?.phone || '-'}</p>
                                            </Alert>
                                        </Col>
                                    </Row>
                                ) : null}
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};